import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const ReportService = {
    softwareAttendance: async (model) => axios.post(API_URL + "/reports/software-attendance", model).then(({data}) => data).catch(err => { throw err }),
    hardwareAttendance: async (model) => axios.post(API_URL + "/reports/hardware-attendance", model).then(({data}) => data).catch(err => { throw err }),
    hardwareAttendanceTime: async (model) => axios.post(API_URL + "/reports/hardware-attendance-time", model).then(({data}) => data).catch(err => { throw err }),
    actions: async (model) => axios.post(API_URL + "/reports/actions", model).then(({data}) => data).catch(err => { throw err }),
    items: async (model) => axios.post(API_URL + "/reports/items", model).then(({data}) => data).catch(err => { throw err }),
    osProject: async (model) => axios.post(API_URL + "/reports/os-project", model).then(({data}) => data).catch(err => { throw err }),
    osProduct: async (model) => axios.post(API_URL + "/reports/os-product", model).then(({data}) => data).catch(err => { throw err }),
    servicesProvided: async (model) => axios.post(API_URL + "/reports/services-provided", model).then(({data}) => data).catch(err => { throw err }),

};

export default ReportService;